import { LoginPage as LoginComponent } from '../components/LoginPage';

export default function LoginPage({ onLogin }) {
  return <LoginComponent onLogin={onLogin} />;
}
